// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file common/common.proto (package lvdr.v2.common, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file common/common.proto.
 */
export const file_common_common: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * PaginationParams controls paginated responses.
 *
 * @generated from message lvdr.v2.common.PaginationParams
 */
export type PaginationParams = Message<"lvdr.v2.common.PaginationParams"> & {
  /**
   * @generated from field: int32 page = 1;
   */
  page: number;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * @generated from field: string cursor = 3;
   */
  cursor: string;
};

/**
 * Describes the message lvdr.v2.common.PaginationParams.
 * Use `create(PaginationParamsSchema)` to create a new message.
 */
export const PaginationParamsSchema: GenMessage<PaginationParams> = /*@__PURE__*/
  messageDesc(file_common_common, 0);

/**
 * SortParams controls sort order.
 *
 * @generated from message lvdr.v2.common.SortParams
 */
export type SortParams = Message<"lvdr.v2.common.SortParams"> & {
  /**
   * @generated from field: string field = 1;
   */
  field: string;

  /**
   * @generated from field: lvdr.v2.common.SortDirection direction = 2;
   */
  direction: SortDirection;
};

/**
 * Describes the message lvdr.v2.common.SortParams.
 * Use `create(SortParamsSchema)` to create a new message.
 */
export const SortParamsSchema: GenMessage<SortParams> = /*@__PURE__*/
  messageDesc(file_common_common, 1);

/**
 * FilterParams supports generic field-level filtering.
 *
 * @generated from message lvdr.v2.common.FilterParams
 */
export type FilterParams = Message<"lvdr.v2.common.FilterParams"> & {
  /**
   * @generated from field: repeated lvdr.v2.common.Filter filters = 1;
   */
  filters: Filter[];
};

/**
 * Describes the message lvdr.v2.common.FilterParams.
 * Use `create(FilterParamsSchema)` to create a new message.
 */
export const FilterParamsSchema: GenMessage<FilterParams> = /*@__PURE__*/
  messageDesc(file_common_common, 2);

/**
 * @generated from message lvdr.v2.common.Filter
 */
export type Filter = Message<"lvdr.v2.common.Filter"> & {
  /**
   * @generated from field: string field = 1;
   */
  field: string;

  /**
   * eq, ne, gt, lt, gte, lte, in, contains
   *
   * @generated from field: string operator = 2;
   */
  operator: string;

  /**
   * @generated from field: string value = 3;
   */
  value: string;
};

/**
 * Describes the message lvdr.v2.common.Filter.
 * Use `create(FilterSchema)` to create a new message.
 */
export const FilterSchema: GenMessage<Filter> = /*@__PURE__*/
  messageDesc(file_common_common, 3);

/**
 * CostInfo reports token and cost information for an operation.
 *
 * @generated from message lvdr.v2.common.CostInfo
 */
export type CostInfo = Message<"lvdr.v2.common.CostInfo"> & {
  /**
   * @generated from field: int32 prompt_tokens = 1;
   */
  promptTokens: number;

  /**
   * @generated from field: int32 completion_tokens = 2;
   */
  completionTokens: number;

  /**
   * @generated from field: double estimated_cost = 3;
   */
  estimatedCost: number;

  /**
   * @generated from field: string model = 4;
   */
  model: string;

  /**
   * @generated from field: string provider = 5;
   */
  provider: string;
};

/**
 * Describes the message lvdr.v2.common.CostInfo.
 * Use `create(CostInfoSchema)` to create a new message.
 */
export const CostInfoSchema: GenMessage<CostInfo> = /*@__PURE__*/
  messageDesc(file_common_common, 4);

/**
 * ProgressInfo reports progress for long-running operations.
 *
 * @generated from message lvdr.v2.common.ProgressInfo
 */
export type ProgressInfo = Message<"lvdr.v2.common.ProgressInfo"> & {
  /**
   * @generated from field: int32 completed = 1;
   */
  completed: number;

  /**
   * @generated from field: int32 total = 2;
   */
  total: number;

  /**
   * @generated from field: double percentage = 3;
   */
  percentage: number;

  /**
   * @generated from field: string current_phase = 4;
   */
  currentPhase: string;

  /**
   * @generated from field: int32 failed = 5;
   */
  failed: number;

  /**
   * @generated from field: int32 in_flight = 6;
   */
  inFlight: number;

  /**
   * @generated from field: int32 max_nodes = 7;
   */
  maxNodes: number;

  /**
   * @generated from field: int32 current_depth = 8;
   */
  currentDepth: number;

  /**
   * @generated from field: int32 max_depth = 9;
   */
  maxDepth: number;

  /**
   * @generated from field: int32 sources_searched = 10;
   */
  sourcesSearched: number;

  /**
   * @generated from field: string phase_detail = 11;
   */
  phaseDetail: string;

  /**
   * batch_queue_depth is how many batch (research) LLM requests are waiting in
   * the Meridian queue cluster-wide — the "high demand" signal the research
   * progress view shows when the run's calls are queued behind others. 0 when
   * the queue is clear or unknown.
   *
   * @generated from field: int32 batch_queue_depth = 12;
   */
  batchQueueDepth: number;
};

/**
 * Describes the message lvdr.v2.common.ProgressInfo.
 * Use `create(ProgressInfoSchema)` to create a new message.
 */
export const ProgressInfoSchema: GenMessage<ProgressInfo> = /*@__PURE__*/
  messageDesc(file_common_common, 5);

/**
 * ReliabilityAssessment holds multi-dimensional reliability scores for a source.
 *
 * @generated from message lvdr.v2.common.ReliabilityAssessment
 */
export type ReliabilityAssessment = Message<"lvdr.v2.common.ReliabilityAssessment"> & {
  /**
   * @generated from field: double trustworthiness = 1;
   */
  trustworthiness: number;

  /**
   * @generated from field: double recency = 2;
   */
  recency: number;

  /**
   * @generated from field: double corroboration = 3;
   */
  corroboration: number;

  /**
   * @generated from field: double composite = 4;
   */
  composite: number;

  /**
   * "high", "medium", "low"
   *
   * @generated from field: string label = 5;
   */
  label: string;

  /**
   * @generated from field: string reasoning = 6;
   */
  reasoning: string;
};

/**
 * Describes the message lvdr.v2.common.ReliabilityAssessment.
 * Use `create(ReliabilityAssessmentSchema)` to create a new message.
 */
export const ReliabilityAssessmentSchema: GenMessage<ReliabilityAssessment> = /*@__PURE__*/
  messageDesc(file_common_common, 6);

/**
 * CorroboratedClaim is a factual assertion found across multiple sources.
 *
 * @generated from message lvdr.v2.common.CorroboratedClaim
 */
export type CorroboratedClaim = Message<"lvdr.v2.common.CorroboratedClaim"> & {
  /**
   * @generated from field: string claim = 1;
   */
  claim: string;

  /**
   * @generated from field: repeated lvdr.v2.common.ClaimSource sources = 2;
   */
  sources: ClaimSource[];

  /**
   * @generated from field: double corroboration_score = 3;
   */
  corroborationScore: number;

  /**
   * "full", "partial", "conflicting"
   *
   * @generated from field: string agreement = 4;
   */
  agreement: string;
};

/**
 * Describes the message lvdr.v2.common.CorroboratedClaim.
 * Use `create(CorroboratedClaimSchema)` to create a new message.
 */
export const CorroboratedClaimSchema: GenMessage<CorroboratedClaim> = /*@__PURE__*/
  messageDesc(file_common_common, 7);

/**
 * ClaimSource identifies a source supporting a corroborated claim.
 *
 * @generated from message lvdr.v2.common.ClaimSource
 */
export type ClaimSource = Message<"lvdr.v2.common.ClaimSource"> & {
  /**
   * @generated from field: string url = 1;
   */
  url: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string quote = 3;
   */
  quote: string;
};

/**
 * Describes the message lvdr.v2.common.ClaimSource.
 * Use `create(ClaimSourceSchema)` to create a new message.
 */
export const ClaimSourceSchema: GenMessage<ClaimSource> = /*@__PURE__*/
  messageDesc(file_common_common, 8);

/**
 * Reusable across domains for delete operations.
 *
 * @generated from message lvdr.v2.common.DeleteConfirmation
 */
export type DeleteConfirmation = Message<"lvdr.v2.common.DeleteConfirmation"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string entity_type = 2;
   */
  entityType: string;
};

/**
 * Describes the message lvdr.v2.common.DeleteConfirmation.
 * Use `create(DeleteConfirmationSchema)` to create a new message.
 */
export const DeleteConfirmationSchema: GenMessage<DeleteConfirmation> = /*@__PURE__*/
  messageDesc(file_common_common, 9);

/**
 * Reusable for subscribe/unsubscribe acknowledgments.
 *
 * @generated from message lvdr.v2.common.SubscribeConfirmation
 */
export type SubscribeConfirmation = Message<"lvdr.v2.common.SubscribeConfirmation"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string entity_type = 2;
   */
  entityType: string;
};

/**
 * Describes the message lvdr.v2.common.SubscribeConfirmation.
 * Use `create(SubscribeConfirmationSchema)` to create a new message.
 */
export const SubscribeConfirmationSchema: GenMessage<SubscribeConfirmation> = /*@__PURE__*/
  messageDesc(file_common_common, 10);

/**
 * ErrorResponse carries structured error information.
 *
 * @generated from message lvdr.v2.common.ErrorResponse
 */
export type ErrorResponse = Message<"lvdr.v2.common.ErrorResponse"> & {
  /**
   * @generated from field: uint32 code = 1;
   */
  code: number;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * @generated from field: map<string, string> details = 3;
   */
  details: { [key: string]: string };
};

/**
 * Describes the message lvdr.v2.common.ErrorResponse.
 * Use `create(ErrorResponseSchema)` to create a new message.
 */
export const ErrorResponseSchema: GenMessage<ErrorResponse> = /*@__PURE__*/
  messageDesc(file_common_common, 11);

/**
 * SourceCitation represents a reference to a source document or URL.
 * Shared across chat messages and research results.
 *
 * @generated from message lvdr.v2.common.SourceCitation
 */
export type SourceCitation = Message<"lvdr.v2.common.SourceCitation"> & {
  /**
   * @generated from field: string document_id = 1;
   */
  documentId: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string excerpt = 3;
   */
  excerpt: string;

  /**
   * @generated from field: double relevance_score = 4;
   */
  relevanceScore: number;

  /**
   * @generated from field: string source_type = 5;
   */
  sourceType: string;

  /**
   * @generated from field: string url = 6;
   */
  url: string;

  /**
   * @generated from field: double reliability_score = 7;
   */
  reliabilityScore: number;

  /**
   * @generated from field: lvdr.v2.common.ReliabilityAssessment reliability_assessment = 8;
   */
  reliabilityAssessment?: ReliabilityAssessment | undefined;

  /**
   * research_id is the owning research for research / cross-research sources —
   * empty for web, library, and note sources. Lets the UI navigate to
   * /research/<research_id> from a source card; without it the FE only had
   * the research NAME (bundled into title) which can't be resolved to a
   * route.
   *
   * @generated from field: string research_id = 9;
   */
  researchId: string;

  /**
   * research_name is the research title this card was PREFIXED with — the
   * post-gate name, not the raw research title.
   *
   *   absent          — a record persisted before this field existed. The FE
   *                     falls back to parsing "[Name] Title" off `title`.
   *   present, empty  — CHAT-13's gate found the research title unsupported by
   *                     its own content and dropped the prefix. The FE MUST
   *                     render no research header. Carrying the raw research
   *                     title here instead would hand a deliberately unlabelled
   *                     card its provenance back through a second channel — the
   *                     exact claim CHAT-13 removed.
   *   present, set    — the gate kept the name; the FE renders the header.
   *
   * `optional` is load-bearing: a plain string cannot distinguish the first two
   * states, and collapsing them strips the header off every message already on
   * disk.
   *
   * Set by the chat pipeline only. research.ws_handler leaves it absent.
   *
   * @generated from field: optional string research_name = 10;
   */
  researchName?: string | undefined;

  /**
   * area names the kind of place the source lives in (AON-08, D47). Absent =
   * not an always-on space, or not known (a record written before the field,
   * or a workspace whose kind could not be read). "always_on" = the user's
   * always-on space. No other value is written. The FE marks a citation only
   * on "always_on".
   *
   * @generated from field: optional string area = 11;
   */
  area?: string | undefined;
};

/**
 * Describes the message lvdr.v2.common.SourceCitation.
 * Use `create(SourceCitationSchema)` to create a new message.
 */
export const SourceCitationSchema: GenMessage<SourceCitation> = /*@__PURE__*/
  messageDesc(file_common_common, 12);

/**
 * CreditInfo is the live credit picture for one run.
 *
 * spent_credits may EXCEED ceiling_credits: hitting the ceiling triggers
 * wind-down, and the synthesis that writes the report then spends past it (see
 * WindDownReason for why that synthesis writes the report — true since RSCH-35). A
 * consumer that assumes spent <= ceiling will render every budget-truncated run
 * wrong — and truncated runs are precisely the ones a user opens this for.
 *
 * @generated from message lvdr.v2.common.CreditInfo
 */
export type CreditInfo = Message<"lvdr.v2.common.CreditInfo"> & {
  /**
   * @generated from field: int64 spent_credits = 1;
   */
  spentCredits: bigint;

  /**
   * 0 means uncapped — render a plain spend readout with no denominator rather
   * than implying a cap that does not exist.
   *
   * @generated from field: int64 ceiling_credits = 2;
   */
  ceilingCredits: bigint;

  /**
   * @generated from field: bool budget_terminated = 3;
   */
  budgetTerminated: boolean;

  /**
   * @generated from field: lvdr.v2.common.WindDownReason wind_down_reason = 4;
   */
  windDownReason: WindDownReason;
};

/**
 * Describes the message lvdr.v2.common.CreditInfo.
 * Use `create(CreditInfoSchema)` to create a new message.
 */
export const CreditInfoSchema: GenMessage<CreditInfo> = /*@__PURE__*/
  messageDesc(file_common_common, 13);

/**
 * LocalizedCopy is one user-visible line expressed as a CATALOGUE KEY plus its ICU
 * arguments, so the client renders it in the user's locale instead of reading English
 * off the wire (CHAT-43c).
 *
 * `key` is the FULL dotted catalogue path — "chat.turnProgress.step.reading" — which is
 * exactly what web/src/lib/i18n/imperative.ts::translateImperative takes, so a non-React
 * caller needs no adapter. It is namespace-ABSOLUTE on purpose: a namespace-relative key
 * would couple the wire to whichever namespace a surface happens to pass to
 * useTranslations().
 *
 * Two argument maps, not one, so a count stays a NUMBER from producer to client. A
 * digits-only string would in fact render the same (next-intl coerces "1" to the `one`
 * arm); what a string map allows is a count the producer already FORMATTED, which does not
 * coerce: "1,000" selects `other` and renders "NaN", and a German "1.000" selects `one` and
 * renders "1". An int64 cannot carry either. Two flat maps also survive the research
 * path's untyped map[string]any hop without a oneof or a nested encoder.
 *
 * @generated from message lvdr.v2.common.LocalizedCopy
 */
export type LocalizedCopy = Message<"lvdr.v2.common.LocalizedCopy"> & {
  /**
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * named string ICU args ({title}, {path})
   *
   * @generated from field: map<string, string> args = 2;
   */
  args: { [key: string]: string };

  /**
   * named NUMERIC args — plural/number selectors
   *
   * @generated from field: map<string, int64> num_args = 3;
   */
  numArgs: { [key: string]: bigint };
};

/**
 * Describes the message lvdr.v2.common.LocalizedCopy.
 * Use `create(LocalizedCopySchema)` to create a new message.
 */
export const LocalizedCopySchema: GenMessage<LocalizedCopy> = /*@__PURE__*/
  messageDesc(file_common_common, 14);

/**
 * @generated from enum lvdr.v2.common.SortDirection
 */
export enum SortDirection {
  /**
   * @generated from enum value: SORT_DIRECTION_UNSPECIFIED = 0;
   */
  SORT_DIRECTION_UNSPECIFIED = 0,

  /**
   * @generated from enum value: SORT_ASC = 1;
   */
  SORT_ASC = 1,

  /**
   * @generated from enum value: SORT_DESC = 2;
   */
  SORT_DESC = 2,
}

/**
 * Describes the enum lvdr.v2.common.SortDirection.
 */
export const SortDirectionSchema: GenEnum<SortDirection> = /*@__PURE__*/
  enumDesc(file_common_common, 0);

/**
 * WindDownReason is the typed cause of a run's wind-down.
 *
 * Wind-down stops NEW research; it does not stop spending. Only research-growing
 * strategy nodes are no-op'd (the coordinator's budgetNoOpsNode, via
 * NodeGrowsGraph): terminal synthesis and, since RSCH-35, the output form's own
 * section writers still run, so the run converges to a partial report instead
 * of no report at all, which means spend can legitimately exceed the ceiling.
 * Consumers must not render or describe wind-down as "spending stopped".
 *
 * Until RSCH-35 this comment was wrong about the report: the section writers
 * were no-op'd too, so a wound-down run produced no report (prod 367bb4e6). A
 * run that still ends with evidence but no report is now salvaged, or finalized
 * FAILED with the reason (the report-root resolver no longer mistakes the
 * output_form code node, or an intermediate assembler such as kp_aggregate, for
 * the report). A run with no usable
 * evidence can still end without a report (the report assembler refuses a
 * document of stub sections) — by design, and not caused by the wind-down. So
 * can a run whose graph already reached its hard node budget before the
 * wind-down latched: the output form then cannot expand (a node reserve for
 * the deliverable is RSCH-36). Nodes emitted before the latch still run.
 *
 * Recorded by the coordinator's windDownLocked from its call sites. Previously
 * the reason existed only as free-text in ResearchMetrics.BudgetWrapUpReason and
 * a transient activity broadcast; this makes it durable, typed data.
 *
 * @generated from enum lvdr.v2.common.WindDownReason
 */
export enum WindDownReason {
  /**
   * @generated from enum value: WIND_DOWN_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * The run hit its credit ceiling. This is the ONLY reason for which raising
   * the ceiling may resume the run.
   *
   * @generated from enum value: WIND_DOWN_REASON_CREDIT_CEILING = 1;
   */
  CREDIT_CEILING = 1,

  /**
   * RSCH-09 scout/dive deepening budget (wall-clock or breadth) exhausted.
   *
   * @generated from enum value: WIND_DOWN_REASON_DEEPENING_BUDGET = 2;
   */
  DEEPENING_BUDGET = 2,

  /**
   * The autonomy ledger reported convergence and latched early.
   *
   * @generated from enum value: WIND_DOWN_REASON_CONVERGED = 3;
   */
  CONVERGED = 3,

  /**
   * The user pressed "Wrap up now".
   *
   * @generated from enum value: WIND_DOWN_REASON_USER_REQUESTED = 4;
   */
  USER_REQUESTED = 4,
}

/**
 * Describes the enum lvdr.v2.common.WindDownReason.
 */
export const WindDownReasonSchema: GenEnum<WindDownReason> = /*@__PURE__*/
  enumDesc(file_common_common, 1);

